<template>
  <button @click.prevent="toggleDm" class="floating-button">
    <IconApecKeyboard class="icon-dim icon-medium" />
  </button>
</template>

<script setup lang="ts">
import { inject } from 'vue';

import IconApecKeyboard from '@/components/icons/IconApecKeyboard.vue';
import { DEFAULT_CHAT_UI_STATE } from '@/utils/constants/chat';
import { ij_chat_ui } from '@/utils/injectionKeys';

const { actions } = inject(ij_chat_ui, DEFAULT_CHAT_UI_STATE);

const emit = defineEmits<{ scrollBottom: [] }>();

const toggleDm = () => {
  actions.toggleDm();
  emit('scrollBottom');
};
</script>

<style scoped>
.floating-button {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  right: 1rem;
  padding: 0.75rem;
  background-color: var(--surface-glass-dimmer);
  backdrop-filter: blur(4px);
  border-radius: 100px;
  outline: solid 1px var(--border-dimmer);
  align-items: center;
  z-index: $z-floating;
}

.scroll-down svg {
  width: 1.25rem;
  height: 1.25rem;
}
</style>
